export class ObjectPool<T extends { active: boolean }> {
  private pool: T[] = [];
  private activeList: T[] = [];
  private factory: () => T;

  constructor(factory: () => T, initialSize = 0) {
    this.factory = factory;
    for (let i = 0; i < initialSize; i++) {
      this.pool.push(this.factory());
    }
  }

  get active(): T[] {
    return this.activeList;
  }

  acquire(): T {
    const obj = this.pool.length > 0 ? this.pool.pop()! : this.factory();
    this.activeList.push(obj);
    return obj;
  }

  release(obj: T): void {
    const idx = this.activeList.indexOf(obj);
    if (idx !== -1) {
      // Swap-and-pop: O(1) removal (order of activeList is not significant)
      const last = this.activeList[this.activeList.length - 1]!;
      this.activeList[idx] = last;
      this.activeList.pop();
    }
    obj.active = false;
    this.pool.push(obj);
  }

  releaseAll(): void {
    for (const obj of this.activeList) {
      obj.active = false;
      this.pool.push(obj);
    }
    this.activeList.length = 0;
  }
}
